import React from 'react';
import { Link } from 'react-router-dom';

function Drawer({ drawer, action }) {
    return (
        <>
            <div
                onClick={(e) => action(e)}
                className={`off_canvars_overlay ${drawer ? 'active' : ''}`}
            ></div>
            <div className="offcanvas_menu">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div
                                className={`offcanvas_menu_wrapper ${
                                    drawer ? 'active' : ''
                                }`}
                            >
                                <div className="canvas_close">
                                    <a href="#menu" aria-label="Close menu" onClick={(e) => action(e)}>
                                        <i className="fa-jelly-fill fa-regular fa-xmark"></i>
                                    </a>
                                </div>
                                <div className="offcanvas-brand text-center mb-40">
                                    <span className="dd-logo-red" role="img" aria-label="Drive.Day" />
                                </div>
                                <div id="menu" className="text-left ">
                                    <ul className="offcanvas_main_menu">
                                        <li className="menu-item-has-children active">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="menu-item-has-children active">
                                            <Link to="/pupil-app">Pupil App</Link>
                                        </li>
                                        <li className="menu-item-has-children active">
                                            <Link to="/about-us">About</Link>
                                        </li>
                                        {/* Blog hidden for now
                                        <li className="menu-item-has-children active">
                                            <Link to="/news">News</Link>
                                        </li> */}
                                        <li className="menu-item-has-children active">
                                            <Link to="/contact">Contact</Link>
                                        </li>
                                    </ul>
                                </div>
                                {/* Social links hidden until the accounts exist
                                <div className="offcanvas-social">
                                    <ul className="text-center">
                                        <li>
                                            <a href="$">
                                                <i className="fab fa-facebook-f"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="$">
                                                <i className="fab fa-twitter"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="$">
                                                <i className="fab fa-instagram"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="$">
                                                <i className="fab fa-dribbble"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Drawer;
